import { ToastType } from '@components';

import { createError } from './errorUtils';
import { handleToast } from './utils';

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      return success;
    } catch (fallbackError) {
      const error = createError(
        fallbackError,
        'Failed to get pending charges data.',
      );
      handleToast(ToastType.Error, error.message);
      return false;
    }
  }
}
